import template from './recapResponseNavigation.html';
import controller from './recapResponseNavigation.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    recapResponse: '<',
    visiblePageIndex: '<',
  },
};

export default component;
